import React from 'react'
import { withStyles, Theme, createStyles, Tab } from '@material-ui/core'

interface StyledTabProps {
  label: string
  onClick: (e: React.MouseEvent | React.KeyboardEvent, value: string) => void
  value: string
}

const NavigationTab = withStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: 'transparent',
      boxShadow: '0 0 1px 0 rgba(0,0,0,0.7)',
      textTransform: 'none',
      color: '#000',
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: theme.typography.pxToRem(15),
      opacity: 0.4,
      '&:focus': {},
      '&$selected': {
        color: '#fff',
        backgroundColor: theme.customColors.info,
        fontWeight: theme.typography.fontWeightMedium,
      },
      [theme.breakpoints.up('tablet')]: {
        height: '2.5em',
      },
    },
    selected: {},
  })
)((props: StyledTabProps) => <Tab disableRipple {...props} onClick={(e) => props.onClick(e, props.value)} />)

export default NavigationTab
